import { ICommonAppSettings, ICommonSettingsFromApi } from '..';

export const chatConfigService = (function () {

    let isChatFeatureAvailable: boolean | null = null;
    let apiSettings: ICommonSettingsFromApi;

    return {

        /**
         * Has this customer chat feature available? Expected to be used for subscribe to SignalR chat. UI uses canShowChat, returned from api.
         */
        isChatFeatureAvailable: (settings: ICommonAppSettings): boolean => {
            isChatFeatureAvailable = settings.isChatFeatureAvailable;
            return settings.isChatFeatureAvailable;
        },

        /**
         * Returns starting(!) availability. In Tipos it may be hidden from SignalR, see ChatListStore
         */
        canShowChatOnStart: (): boolean => {
            if (isChatFeatureAvailable === null) {  // TODO synot and tipos bet detail https://tst-sport-synottip-cz.easit.cz/muj-tiket/9938086665 fails , fix it!
                isChatFeatureAvailable = false;
                //throw new Error("isChatFeatureAvailable not set");
            }
            if (apiSettings.canShowChat) {
                if (isChatFeatureAvailable) {
                    return true;
                }
                //TODO see above throw new Error("isChatFeatureAvailable is false, but ShowChat from api is true");
            }
            return false;
        },

        setApiSettings: (data: ICommonSettingsFromApi): void => {
            apiSettings = data;
        }
    }
})();